import { useQueryClient } from "@tanstack/react-query";
import type { FC } from "react";

import { NOTIFICATION_BROADCAST_EVENT_CHANNEL, notificationEventChannel } from "@recobra/core";

import { useDocumentEvents } from "../documents";

export const NotificationEventInvalidation: FC<{ userId: string }> = ({ userId }) => {
  const queryClient = useQueryClient();
  const invalidate = () => {
    void queryClient.invalidateQueries({ queryKey: ["notifications"] });
  };

  useDocumentEvents(notificationEventChannel(userId), invalidate);
  useDocumentEvents(NOTIFICATION_BROADCAST_EVENT_CHANNEL, invalidate);

  return null;
};
